import { SliderMark } from '@umss/shared/utils';

export const DISTANCES: SliderMark[] = [
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 30, label: '30' },
  { value: 40, label: '40' },
  { value: 50, label: '50' },
  { value: 70, label: '70' },
  { value: 100, label: '100' }
];
